var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscountmanagemnt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 1.83331H9.99992C13.3333 1.83331 14.6666 3.16665 14.6666 6.49998V10.5C14.6666 13.8333 13.3333 15.1666 9.99992 15.1666H5.99992C2.66659 15.1666 1.33325 13.8333 1.33325 10.5V6.49998C1.33325 3.16665 2.66659 1.83331 5.99992 1.83331Z",
    stroke: "#0B0311",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71338 10.68L10.0734 6.32001",
    stroke: "#0B0311",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.98676 7.41331C6.43963 7.41331 6.80674 7.0462 6.80674 6.59332C6.80674 6.14045 6.43963 5.77332 5.98676 5.77332C5.53388 5.77332 5.16675 6.14045 5.16675 6.59332C5.16675 7.0462 5.53388 7.41331 5.98676 7.41331Z",
    stroke: "#0B0311",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3466 11.2267C10.7995 11.2267 11.1666 10.8595 11.1666 10.4067C11.1666 9.95378 10.7995 9.58667 10.3466 9.58667C9.89372 9.58667 9.52661 9.95378 9.52661 10.4067C9.52661 10.8595 9.89372 11.2267 10.3466 11.2267Z",
    stroke: "#0B0311",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountmanagemnt);
export default __webpack_public_path__ + "static/media/discountmanagemnt.cf11bb67e910041d0615cc3c47405f76.svg";
export { ForwardRef as ReactComponent };